import axios from "../../config/axiosConfig";
import {
  TDS_REPORT_REQUEST,
  TDS_REPORT_SUCCESS,
  TDS_REPORT_FAILURE
} from "../types/tds-report-types";

export const getTdsReport = (params) => {
  return async (dispatch, getState) => {
    try {
      dispatch({ type: TDS_REPORT_REQUEST });

      const { auth } = getState();
      const defaultParams = {
        // userId: auth.user?.id,
        finyearId: auth.finyear?.id,
        companyId: auth.company?.id,
        customerId: auth.user?.Customer_Id,
      };
      // console.log('params.book_ids',params);
      console.log('params.fromDate',params?.fromDate);
      console.log('params.toDate',params?.toDate);
      
      const defaultParams2 = {
        selectedParties: params?.selectedParties, 
        fromDate: params?.fromDate, 
        toDate: params?.toDate, 
        ...params
      };
      // Merge default params with provided params
      const requestParams = { ...defaultParams, ...defaultParams2 };

      // Construct the complete URL with query parameters
      const queryString = new URLSearchParams(requestParams).toString();
      const fullUrl = `/tds-report/getReport?${queryString}`;

      console.log('Complete API Request URL: ', fullUrl);

      return axios.get(fullUrl).then((response) => {
        console.log('API Response Data: ', response);
        // Dispatch success action with data
        if (response.data) {
          dispatch({ type: TDS_REPORT_SUCCESS, payload: response.data });
        }
        return response.data;
      }).catch((error) => {
        console.error("Error fetching TDS Report:", error);
        dispatch({ type: TDS_REPORT_FAILURE, error: error.message });  
      });
    } catch (error) {
      console.error("Error fetching TDS Report:", error);
      dispatch({ type: TDS_REPORT_FAILURE, error: error.message });
    }
  };
};

export const clearTdsReport = () => {
  return async (dispatch) => {
    dispatch({ type: TDS_REPORT_SUCCESS, payload: {} });
  }
}
